import React, { memo } from "react";
import Theme from "../../style/Theme";
import { Colors } from "../../configs";
import Text from "../../components/Text";
import Tooltip from "../../components/Tooltip";
import { View, StyleSheet } from "react-native";
import { IoInformationCircleOutline } from "react-icons/io5";
interface AdditionalItemProps {
  title: string;
  time?: string;
  isLast?: boolean;
  value?: string | null;
  masked?: boolean;
}

const AdditionalItem = memo((props: AdditionalItemProps) => {

  const TooltipMask = () => {
      return (
        <Tooltip
          fontSize="0.85rem"
          width="180px"
          text="Este dato está protegido. Consulte con su institución si requiere acceso."
          backgroundColor="white"
          color="black"
          border="1px solid black"
          transform="translateX(-100%) translateY(-120%)"
        >
          <IoInformationCircleOutline size={25} color={Colors.TealBlue} />
        </Tooltip>
      );
    };

  return (
    <View style={!props.isLast && { marginBottom: 28 }}>
      <Text size={15} lineHeight={18} bold>
        {props.title}
      </Text>
      <Text
        size={15}
        lineHeight={18}
        marginTop={12}
        color={
          props.value && props.value.length > 0
            ? Colors.DarkJungleGreen
            : Colors.GrayBlue
        }
      >
        {props.value && props.value.length > 0 ? props.value : "No tiene"}
        {props.time && (
          <Text size={13} lineHeight={16} color={Colors.GrayBlue}>
            {" "}
            ({props.time})
          </Text>
        )}
        {props.masked && (
          <View
            style={{
              position: "absolute",
              right: 8,
              top: "50%",
              transform: [{ translateY: 0 }],
              zIndex: 10,
              pointerEvents: "box-none",
            }}
          >
            <TooltipMask />
          </View>
        )}
      </Text>
    </View>
  );
});

export default AdditionalItem;

const styles = StyleSheet.create({
  container: {
    borderRadius: 16,
    paddingTop: 16,
    paddingBottom: 24,
    ...Theme.shadow,
  },
});
